// Lib
import SingleIntersectionObserver from 'lib/SingleIntersectionObserver';

const shopifySections = [...document.querySelectorAll('.shopify-section')];

const observer = new SingleIntersectionObserver(
  (entries) => {
    entries.forEach(({ target }) => target.classList.add('seen'));
  },
  {
    root: null,
    rootMargin: '0px 0px -200px 0px',
    threshold: 0.5,
  },
);

shopifySections.forEach((section) => {
  observer.observe(section);
});
